import { Card, CardContent, Typography } from "@mui/material";

import { getScoreColor } from "../utils/scoreColor";

function MetricCard({ title, value, score }) {
  return (
    <Card
      sx={{
        height: 150,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 200,
      }}
    >
      <CardContent>
        <Typography color="text.secondary">{title}</Typography>

        <Typography
          variant="h3"
          fontWeight={700}
          sx={{
            color: getScoreColor(score),
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default MetricCard;
